import { createSelector } from '@ngrx/store';

import * as fromRoot from '@usimweb/state/router-store';
import * as fromFeature from '../reducers';
import * as fromProjects from '../reducers/projects.reducer';

import { AuthHandler } from '@usimweb/core-auth';
import { Projects, Versions } from '@usimweb/core/models';
import { Helper } from '../helper';

// Projects state
export const getProjectsState = createSelector(fromFeature.getProductsState, (state: fromFeature.DashboardState) => state.projects);

export const getProjectssEntities = createSelector(getProjectsState, fromProjects.getProjectsEntities);

export const getProjectsFiltered = createSelector(getProjectsState, fromProjects.getProjectsFiltered);

// export const getVersionsFiltered = createSelector(getProjectsState, fromProjects.getVersionsFiltered);

//entites increasing speed
//no loop through array needed to get specific obj
export const getSelectedProject = createSelector(getProjectssEntities, fromRoot.getRouterState, (entities, router): Versions[] => {
  if (Object.keys(entities).length > 0) {
    const versions = entities[router.state.params['id']].versions;
    return versions;
  }
  return [];
});

//reminder initialState:
// {data: [], loaded: false, loading: false}

//this selector gets "data" from the initialstate
export const getAllProjects = createSelector(getProjectssEntities, getProjectsFiltered, (entities, filter) => {
  const projects = Object.keys(entities).map((uuid: string) => entities[uuid]);

  let filtered = projects.filter((project) => {
    if (filter.visibilityFilter == '-') {
      return projects;
    }

    const created_by = project.created_by?.toLocaleLowerCase();
    const currentUser = AuthHandler.basfUserName.toLocaleLowerCase();

    if (filter.visibilityFilter === 'favourite' && project.is_favorite === true) {
      return project;
    }

    if (filter.visibilityFilter === 'shared' && currentUser !== created_by) {
      return project;
    }
    return;
  });

  filtered = filtered.filter((project: Projects) => {
    if (!filter.favouriteFilter) {
      return filtered;
    }

    return;
  });

  const searchText = filter.searchFilter;
  filtered = filtered.filter((project: any) => {
    //FIX ME in backend
    if (project.hasOwnProperty('title')) {
      return project.title.toLowerCase().includes(searchText);
    }
    if (project.hasOwnProperty('name')) {
      return project.name.toLowerCase().includes(searchText);
    }
    return;
  });

  return filtered.sort(function (x, y) {
    return Helper.getTimeStampFromDate(y.created_at) - Helper.getTimeStampFromDate(x.created_at);
  });
});

export const getProjectById = (uuid: string) =>
  createSelector(getProjectssEntities, (projects) => {
    // console.log('get project from selector');
    // console.log(projects);

    return projects[uuid];
  });

//this selector gets "loaded" from the initialstate
export const getProjectsLoaded = createSelector(getProjectsState, fromProjects.getProjectsLoaded);

//this selector gets "loading" from the initialstate
export const getProjectsLoading = createSelector(getProjectsState, fromProjects.getProjectsLoading);

export const getProjectsCreated = createSelector(getProjectsState, fromProjects.getProjectCreated);

export const getPublicProjects = createSelector(getProjectssEntities, (entities) => {
  const projects = Object.keys(entities).map((uuid: string) => entities[uuid]);

  return projects.filter((project) => {
    const created_by = project.created_by;
    const currentUser = AuthHandler.basfUserName.toLocaleLowerCase();
    if (currentUser !== created_by) {
      return true;
    }
    return false;
  });
});

export const getPrivateProjects = createSelector(getProjectssEntities, (entities) => {
  const projects = Object.keys(entities).map((uuid: string) => entities[uuid]);

  return projects.filter((project) => {
    const created_by = project.created_by;
    const currentUser = AuthHandler.basfUserName.toLocaleLowerCase();
    if (currentUser === created_by) {
      return true;
    }
    return false;
  });
});
